export default "__VITE_ASSET__CnoXDNQE__"